import { render } from "./CompanyArticlePage.vue?vue&type=template&id=1bf4d419&scoped=true"
import script from "./CompanyArticlePage.vue?vue&type=script&lang=js"
export * from "./CompanyArticlePage.vue?vue&type=script&lang=js"

import "./CompanyArticlePage.vue?vue&type=style&index=0&id=1bf4d419&scoped=true&lang=css"

import exportComponent from "C:\\Projekte\\repos\\datentool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf4d419"]])

export default __exports__